import { useEffect, useState } from "react";
import { NavLink, Link, useLocation } from "react-router-dom";
import { Menu, X, CalendarHeart } from "lucide-react";
import { NAV, SITE } from "@/lib/site";

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => { setOpen(false); }, [location.pathname]);

  return (
    <header
      data-testid="site-navbar"
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-300 ${
        scrolled ? "bg-white/85 backdrop-blur-md shadow-[0_6px_24px_-14px_rgba(31,41,55,0.18)]" : "bg-white/60 backdrop-blur-sm"
      }`}
    >
      <div className="na-container flex items-center justify-between py-3">
        <Link to="/" className="flex items-center gap-3" data-testid="nav-logo">
          <img src={SITE.logo} alt="Nari Arogya logo" className="h-12 md:h-14 w-auto object-contain" />
        </Link>

        <nav className="hidden lg:flex items-center gap-8">
          {NAV.map((n) => (
            <NavLink
              key={n.to}
              to={n.to}
              end={n.to === "/"}
              className={({ isActive }) => `nav-link ${isActive ? "active" : ""}`}
              data-testid={`nav-link-${n.label.toLowerCase().replace(/\s+/g, "-")}`}
            >
              {n.label}
            </NavLink>
          ))}
        </nav>

        <div className="hidden lg:flex items-center gap-3">
          <Link to="/book" className="btn-primary text-sm" data-testid="nav-book-btn">
            <CalendarHeart size={16} /> Book Appointment
          </Link>
        </div>

        <button
          className="lg:hidden p-2 text-[color:var(--na-text)]"
          onClick={() => setOpen((v) => !v)}
          aria-label="Toggle menu"
          data-testid="mobile-menu-toggle"
        >
          {open ? <X size={26} /> : <Menu size={26} />}
        </button>
      </div>

      {open && (
        <div className="lg:hidden border-t border-[color:var(--na-border)] bg-white" data-testid="mobile-menu">
          <div className="na-container py-4 flex flex-col gap-2">
            {NAV.map((n) => (
              <NavLink
                key={n.to}
                to={n.to}
                end={n.to === "/"}
                className={({ isActive }) => `py-2 nav-link ${isActive ? "active" : ""}`}
                data-testid={`mobile-nav-link-${n.label.toLowerCase().replace(/\s+/g, "-")}`}
              >
                {n.label}
              </NavLink>
            ))}
            <Link to="/book" className="btn-primary mt-2 justify-center" data-testid="mobile-nav-book">
              <CalendarHeart size={16} /> Book Appointment
            </Link>
          </div>
        </div>
      )}
    </header>
  );
}
